<template>
    <div>
        <modal :show="show" :close="() => {}">
            <template #header>
                <h1 class="header">Recalculating Payments</h1>
            </template>

            <template #body>
                <div class="body-text">
                    {{ $t("modal.recalculate.body", { frequency: frequency }) }}
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"
    import { capitalize } from "lodash"

    export default {
        name: "PaymentRecalculatingModal",
        components: {
            Modal,
        },
        props: {
            frequency: {
                type: String,
                default: "monthly",
            },
            show: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            capitalizedFrequency() {
                return capitalize(this.frequency)
            },
        },
    }
</script>
